module.exports = __webpack_public_path__ + "img/cafe-expresso.a802a334.jpg";